import React, { createContext, useState, useEffect } from 'react';
import api from '../api/axiosConfig';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchUser = async () => {
    try {
      const res = await api.get('/auth/profile');
      setUser(res.data);
      // 로그인 직후 역할에 따라 갈 곳이 다르다. setUser 는 다음 렌더에나 반영
      // 되므로 부른 쪽이 바로 쓸 수 있게 돌려준다.
      return res.data;
    } catch (error) {
      console.error('Failed to fetch user profile:', error);
      localStorage.removeItem('token');
      setUser(null);
      return null;
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      fetchUser();
    } else {
      setLoading(false);
    }
  }, []);

  const login = async (accessToken, refreshToken) => {
    localStorage.setItem('token', accessToken);
    if (refreshToken) {
      localStorage.setItem('refreshToken', refreshToken);
    }
    return fetchUser();
  };

  const logout = async () => {
    try {
      if (localStorage.getItem('token')) {
        // 이 기기의 푸시 토큰도 함께 끊는다. 안 보내면 로그아웃한 뒤에도 이
        // 기기로 알림이 가고, 회사 폰을 넘겨받은 다음 사람이 아직 로그인하지
        // 않은 사이에는 앞사람의 알림을 받는다.
        await api.post('/auth/logout', {
          deviceToken: localStorage.getItem('fcmToken') || undefined,
        });
      }
    } catch (e) {
      console.error(e);
    } finally {
      localStorage.removeItem('token');
      localStorage.removeItem('refreshToken');
      setUser(null);
    }
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, loading }}>
      {children}
    </AuthContext.Provider>
  );
};

export default AuthContext;
